import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const ProtectedRoute = () => {
  const { session, loading, missingProfile } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50">
        <SafeIcon icon={FiIcons.FiLoader} className="animate-spin h-10 w-10 text-slate-600 mb-4" />
        <p className="text-slate-600 font-medium">Verifying session...</p>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If session exists but profile is missing, force them to the error screen
  if (missingProfile && location.pathname !== '/missing-profile') {
    return <Navigate to="/missing-profile" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;